import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ProductModel } from '@app/models';

@Injectable({
    providedIn: 'root',
})
export class ProductService
{
    private endPoint = '/products';
    private http = inject(HttpClient);

    getProducts(): Promise<ProductModel[]>
    {
        return firstValueFrom(this.http.get<ProductModel[]>(this.endPoint));
    }
}
